import { media } from '~theme/breakpoints';
export const main = {
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100vh'
};

if (typeof main !== 'undefined' && main && main === Object(main) && Object.isExtensible(main) && !main.hasOwnProperty('__filemeta')) {
  Object.defineProperty(main, '__filemeta', {
    configurable: true,
    value: {
      name: "main",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Layout/styles.js"
    }
  });
}

export const wrapper = {
  py: 0,
  flex: 1,
  display: 'grid',
  gridTemplateColumns: '250px minmax(0, 1fr)',
  minHeight: '100vh',
  [media.tablet]: {
    display: 'block'
  }
};

if (typeof wrapper !== 'undefined' && wrapper && wrapper === Object(wrapper) && Object.isExtensible(wrapper) && !wrapper.hasOwnProperty('__filemeta')) {
  Object.defineProperty(wrapper, '__filemeta', {
    configurable: true,
    value: {
      name: "wrapper",
      filename: "../../node_modules/gatsby-theme-docz/src/components/Layout/styles.js"
    }
  });
}